.icon {
  padding: 4px;
}

.draggable {
  width: 4px;
  height: 35px;
  background: #e4e7ec;
  position: absolute;
  left: 5px;
  border-radius: 100px;
  z-index: 9999;
  top: calc(50vh - 12px);
  user-select: none;
}

.draggable:hover {
  background: #98a2b3;
  cursor: col-resize;
}

.curve {
  width: 25px;
  height: 25px;
  position: absolute;
  background-color: #f6f6f4;
}
